module.exports = __webpack_public_path__ + "static/media/CustomerMt.f8f32eb9.svg";